import { render, staticRenderFns } from "./_gameList.vue?vue&type=template&id=714b3fb8&lang=pug&"
import script from "./_gameList.vue?vue&type=script&lang=js&"
export * from "./_gameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports